export default {
    stateLocations: {
        AgentAssist: {
            Base: "AgentAssist",
            callId: "callId",
            history: "history",
        },
        AlmeNotifications: {
            Base: "AlmeNotifications",
            getNotificationsRequest: "GetNotificationsRequest",
            pollingActive: "PollingActive",
            processedResponse: "ProcessedResponse",
            receivedResponse: 'ReceivedResponse',
            stagedRequest: 'StagedRequest',
        },
        AutoNav: {
            Base: "AutoNav",
            isNavigating: "IsNavigating",
            stagedEvent: "StagedEvent",
            stagedNav: "StagedNav",
            watches: [
                "AutoNav.StagedNav",
            ],
        },
        ClientCommunicator: {
            AllowedOrigins: "AllowedOrigins",
            Base: "ClientCommunicator",
            ReceivedMessages: "ReceivedMessages",
        },
        CommandAction: {
            Base: 'CommandAction',
            PageLoadActions: 'PageLoadActions',
        },
        Conversation: {
            accessKey: "AccessKey",
            Base: "Conversation",
            channel: "Channel",
            customSessionId: "CustomSessionId",
            inputProcessing: "InputProcessing",
            inputProperties: {
                Base: "inputProperties",
                ClientSessionId: "ClientSessionId",
                IsLoggedIn: "IsLoggedIn",
            },
            isActiveSession: 'IsActiveSession',
            language: "Language",
            notificationMessage: "NotificationMessage",
            previousWeblinks: "PreviousWeblinks",
            processedInput: "ProcessedInput",
            processedResponse: "ProcessedResponse",
            receivedResponse: "ReceivedResponse",
            receivedResponseWatches: [
                "Conversation.ReceivedResponse",
                "History.ReceivedResponse",
            ],
            sentInput: "SentInput",
            sessionId: 'SessionId',
            showNotification: "ShowNotification",
            userId: "UserId",
            userMetadata: "UserMetadata",
        },
        CookieCommunicator: {
            cookieWatches: {
                /*
                * yourCookieName: {
                *   stateLocation: "cookieStateLocation"
                * }
                */
            },
            stateWatches: {
                /*
                * yourObjectPath: {
                *   cookieName: "yourCookieName"
                * }
                */
            },
        },
        DeviceType: "DeviceType",
        DisplayLinks: {
            Base: "Window.DisplayLinks",
        },
        Email: {
            emailStageLocation: "EmailStageLocation",
            stateWatches: [
            ],
        },
        EndChatWarning: {
            Base: "EndChatWarning",
            Visible: "visible",
        },
        FeedbackAppEvent: {
            Base: "FeedbackAppEvent",
            staging: "StagedAppEvent",
        },
        HelpReporter: {
            Base: "HelpReporter",
            stagedEvent: "aboutTheIVAEventName",
        },
        History: {
            Base: 'History',
            capturedFeedback: "CapturedFeedback",
            capturedStageLocation: "CapturedFeedbackStaging",
            displayFeedback: "DisplayFeedback",
            feedbackPanes: "FeedbackPanes",
            shouldFocus: "shouldFocus",
            initialize: "Initialize",
            Messages: 'HistoryMessages',
            RawMessages: "RawMessages",
        },
        Initialization: {
            Base: "Initialization",
        },
        JwtAuthentication: {
            Base: "JwtAuthentication",
            almeKey: "almeKey",
        },
        LiveChat: {
            AgentName: "AgentName",
            Base: "LiveChat",
            BeginChatExtStaging: {
                Base: "BeginChatExtStaging",
                ReceivedResponse: "ReceivedResponse",
            },
            ChatEvent: {
                Base: "ChatEvent",
                ReceivedResponse: "ReceivedResponse",
            },
            ConnectionStatus: "ConnectionStatus",
            FilterCurrentChatMessagesOnReload: "FilterCurrentChatMessagesOnReload",
            GetChatStatusStaging: {
                Base: "GetChatStatusStaging",
                ReceivedResponse: "ReceivedResponse",
            },
            GetMessagesExtStaging: {
                Base: "GetMessagesExtStaging",
                ProcessResponse: "ProcessResponse",
            },
            LastSeenIndex: 'LastSeenIndex',
            NextMessageIndex: "NextMessageIndex",
            operatorData: 'OperatorData',
            OperatorDisconnectStaging: {
                Base: "OperatorDisconnectStaging",
            },
            operatorTyping: 'OperatorTyping',
            queueText: 'QueueText',
            sessionState: 'SessionState',
            SkipLiveChatInitialize: "SkipLiveChatInitialize",
            UserDisconnectStaging: {
                Base: "UserDisconnectStaging",
                ReceivedResponse: "ReceivedResponse",
            },
            userTyping: 'UserTyping',
        },
        PersistentStorage: {
            Base: 'PersistentStorage',
            watches: {
                NITAlme: [
                    'CommandAction.PageLoadActions',
                    "Conversation.AccessKey",
                    "Conversation.IsActiveSession",
                    "Conversation.SessionId",
                    "Survey.metaData",
                    "Survey.reason",
                    "Survey.comment",
                    "Window.IsMinimized",
                    "Window.Position",
                    "Window.Size",
                    "JwtAuthentication.almeKey",
                    "WelcomeUser.SuppressAction",
                ],
                NITAlmeUser: [
                    "Conversation.UserId",
                ],
            },
        },
        ResponseDropdown: {
            Base: "ResponseDropdown",
            shouldDisable: "shouldDisable",
            shouldFocus: "shouldFocus",
            isVisible: "isVisible",
            responseRevision: "responseRevision",
        },
        Session: {
            Base: "Session",
            GenerateNew: "GenerateNew",
            IsClosed: "IsClosed",
        },
        Survey: {
            Base: "Survey",
            Comment: "Comment",
            EntryId: "EntryId",
            MetaData: "metaData",
            DisplaySurvey: "DisplaySurvey",
            Reason: "reason",
            SelectedReasonIndex: "selectedReasonIndex",
            SurveyId: "surveyId",
            SurveyRendered: "surveyRendered",
            SurveyUnitLabel: "SurveyUnitLabel",
            Visible: "visible",
        },
        TimeoutWarning: {
            Base: "TimeoutWarning",
            InactivityTime: "inactivityTime",
            SessionStartTime: "sessionStartTime",
            Visible: "visible",
        },
        TTS: {
            audioPlayTimer: "AudioPlayTimer",
            Base: "TTS",
            lastPrvUrl: "LastPrvUrl",
            playPrvOnNav: "PlayPrvOnNav",
            playStateWatches: ["Window.IsSound"],
            shouldPlay: "ShouldPlay",
            soundMonitorTimer: "SoundMonitorTimer",
            stopStateWatches: ["Window.IsMinimized"],
            wasPlayed: "WasPlayed",
        },
        UserLoginLogoutAppEvent: {
            Base: "UserLoginLogoutAppEvent",
            staging: "StagedAppEvent",
        },
        VersionReporter: {
            Base: "VersionReporter",
        },
        WelcomeUser: {
            Base: "WelcomeUser",
            forceIsActiveSession: "ForceIsActiveSession",
            launchParameter: "LaunchParameter",
            launchPointName: "LaunchPointName",
            launchType: "LaunchType",
        },
        Window: {
            IsEmbedded: "IsEmbedded",
            Accordion: {
                Base: "Accordion",
                expandedPanels: "expandedPanels",
                shouldDisable: "shouldDisable",
            },
            AlmeMessage: {
                Base: "AlmeMessage",
                shouldDisable: "shouldDisable",
            },
            bannerText: "BannerText",
            Base: "Window",
            CallToActionButton: {
                Base: "CallToActionButtons",
                shouldDisable: "shouldDisable",
            },
            currentTree: "CurrentTree",
            DisplayLinks: {
                Base: "DisplayLinks",
                shouldDisable: "shouldDisable",
            },
            DisplayLinksUrl: {
                Base: "DisplayLinksUrl",
                shouldDisable: "shouldDisable",
            },
            ExpandedPanes: "ExpandedPanes",
            ForceRender: "ForceRender",
            InlineSurveyLinks: {
                Base: "InlineSurveyLinks",
                shouldDisable: "shouldDisable",
            },
            Input: {
                Base: "Input",
                CurrentInput: "CurrentInput",
                StageLocation: "StageLocation",
            },
            IsBlocked: "IsBlocked",
            isDragging: "IsDragging",
            IsMinimized: "IsMinimized",
            isResizing: "IsResizing",
            IsSound: "IsSound",
            InputBoxLocked: {
                Base: "InputBoxLocked",
                isInputBoxLocked: "isInputBoxLocked",
                ReenableOnLinkClick: "ReenableOnLinkClick",
                ReenableWelcomeUser: "ReenableWelcomeUser",
            },
            MinimizeButton: {
                Base: "MinimizeButton",
                shouldDisable: "shouldDisable",
            },
            NavUrl: {
                Base: "NavUrl",
                shouldDisable: "shouldDisable",
            },
            position: "Position",
            ReportingEvent: {
                Base: "ReportingEvent",
                StageLocation: "StageLocation",
            },
            size: "Size",
            Skin: "Skin",
            SkipToContent: {
                Base: "SkipToContent",
                shouldDisable: "shouldDisable",
                ShouldSkipToContent: "shouldSkipToContent",
            },
            TimeoutWarning: {
                Base: "TimeoutWarning",
                InactivityTime: "inactivityTime",
                ResetPersist: "resetPersist",
                SessionStartTime: "sessionStartTime",
                Visible: "visible",
            },
            UserMessage: {
                Base: "UserMessage",
                shouldDisable: "shouldDisable",
            },
            WindowForm: {
                Base: "WindowForm",
                shouldDisable: "shouldDisable",
                isMultiSelectOpen: "isMultiSelectOpen",
                Counter: "counter",
            },
            currentIndex: "currentIndex",            
        },        
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/state-locations.ts